import { render, staticRenderFns } from "./ReportDetail.vue?vue&type=template&id=44927e94&scoped=true"
import script from "./ReportDetail.vue?vue&type=script&lang=js"
export * from "./ReportDetail.vue?vue&type=script&lang=js"
import style0 from "./ReportDetail.vue?vue&type=style&index=0&id=44927e94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44927e94",
  null
  
)

export default component.exports